import React, { Component } from 'react'
import moment from 'moment'

import './home.css'
import IconPeople from '../svg/iconpeople'
import IconPhone from '../svg/iconphone'
import IconTitle from '../svg/icontitle'
import Background from '../svg/background'
import { t } from 'i18next'

import { connect } from 'react-redux'
import { SHOW_MODAL, SHOW_PAGE, RESET_QUESTION } from '../actions'

class Home extends Component {
  constructor(props) {
    super(props)

    this.state = {
      size: this.calc()
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = e => {
    this.setState({
      size: this.calc()
    })
  }

  calc = () => {
    const vw = window.outerWidth
    return Math.min(24, 0.053 * vw)
  }

  render() {
    const { updatePage, trivia, showWarning, user, syncProgress } = this.props
    const { noQuestions, questions, current } = trivia
    const { progress } = user
    const warning = progress === trivia.questions.length

    if (progress > current) {
      setTimeout(() => {
        syncProgress(progress)
      }, 500)
    }

    const clickHander = e => {
      warning ? showWarning() : updatePage('trivia')
    }

    const last = questions[questions.length - 1]
    const date = moment(last.Start).format(t('home.questions.date'))
    const { size } = this.state

    return (
      <div className="view-inner">
        <div className="home-container">
          <div className="home-hero">
            <Background className="icon-background" />
            <IconPeople />
          </div>
          <h1 className="home-title">
            <IconTitle />
          </h1>
          <div className="home-subtitle text-center" style={{ fontSize: size }}>
            {t('home.subtitle')}
          </div>
          <div className="home-content text-center">
            <div className="home-play">
              <button className="btn btn-blue btn-play rounded" onClick={clickHander}>
                <IconPhone />
                {t('home.play')}
              </button>
            </div>
            <div className="home-ranking">
              <button className="btn" onClick={e => updatePage('ranking-home')}>
                {t('home.ranking')}
              </button>
            </div>
          </div>

          <footer className="footer text-center">
            {noQuestions ? t('home.questions.none') : t('home.questions.new', { date })}
          </footer>
        </div>
      </div>
    )
  }
}

const mapState = ({ trivia, user }) => {
  return { trivia, user }
}

const mapDispatch = dispatch => {
  return {
    showWarning: () => {
      dispatch({
        type: SHOW_MODAL,
        payload: 'warning'
      })
    },
    updatePage: page => {
      dispatch({
        type: SHOW_PAGE,
        payload: page
      })
    },
    syncProgress: progress => {
      dispatch({
        type: RESET_QUESTION,
        payload: progress
      })
    }
  }
}

const Connect = connect(mapState, mapDispatch)(Home)
Connect.displayName = 'home'

export default Connect



// WEBPACK FOOTER //
// ./src/pages/Home.js